import styles from "./Submit.module.scss";
import * as React from "react";

/**
 * Note that there is no onSubmit handler. This component should be embedded in
 * a Form with an onSubmit handler.
 */
export interface SubmitProps {
    /** Label defaults to "Save" if not set */
    label?: string;
    /** Disable and apply animation */
    is_pending?: boolean;
}

export const Submit = (props: SubmitProps) => {
    return (
        <input className={styles.submit} type="submit" disabled={props.is_pending} value={props.label || "Save"} />
    )
};

export default Submit;
